module.exports = __webpack_public_path__ + "img/4.82f0b408.png";